import React from 'react'
import Heading from './itemsPreview/Heading'
import CheckList from './itemsPreview/CheckList'
import Divider from './itemsPreview/Divider'
import Dropdown from './itemsPreview/Dropdown'
import SimpleQuestion from './itemsPreview/SimpleQuestion'
import SingleChoice from './itemsPreview/SingleChoice'
import MultiChoice from './itemsPreview/MultiChoice'
import RatingScale from './itemsPreview/RatingScale'
import YesNoQuestion from './itemsPreview/YesNoQuestion'
import Notes from './itemsPreview/Notes'
import Table from './itemsPreview/Table'
import File from './itemsPreview/File'
import Date from './itemsPreview/Date'
import TextField from './itemsPreview/TextField'
import FormattingTextField from './itemsPreview/FormattingTextField'
import isNull from '../../../../../../../../../utils/NullChecking'

const RenderFieldPreview = ({ item, setItem, activeAccordion, isGroupNote, ...props }) => {
  switch (!isNull(item.ItemID) && item.ItemID.split('-')[0]) {
    // Use the base ID to determine the type
    case 'Heading':
      return <Heading item={item} isGroupNote={isGroupNote} />;

    case 'TextField':
      return <TextField item={item} isGroupNote={isGroupNote} />;

    case 'FormattingTextField':
      return <FormattingTextField item={item} isGroupNote={isGroupNote} />;

    // case 'Checklist':
    case 'CheckList':
      return <CheckList item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount}  />;

    case 'Divider':
      return <Divider item={item} setItem={setItem} activeAccordion={activeAccordion} />;

    case 'Dropdown':
      return <Dropdown item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'SimpleQuestion':
      return <SimpleQuestion item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'SingleChoice':
      return <SingleChoice item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'MultiChoice':
      return <MultiChoice item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'RatingScale':
      return <RatingScale item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'YesNoQuestion':
      return <YesNoQuestion item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'Notes':
      return <Notes item={item} setItem={setItem} activeAccordion={activeAccordion} isGroupNote={isGroupNote} />;

    case 'Table':
      return <Table item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'File':
      return <File item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'Image':
      return <File item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'Signature':
      return <File item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'Date':
      return <Date item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    default:
      return null;
  }
}

export default RenderFieldPreview